import React, { useEffect, useState } from "react";
import ControlReasonsModal from "./ControlReasonsModal.jsx";
import { ClickAwayListener, Portal } from "@mui/base";
import RegNumberDetails from "./RegNumberDetails.jsx";
import CustomerDetails from "./CustomerDetails.jsx";
import DealerDetails from "./DealerDetails.jsx";
import { RphUserIds } from "../../../utils/constant.js";
import { useSelector } from "react-redux";

const DetailHeader = ({ caseDetails, user_id, statuses, substatuses }) => {
  const detailsStore = useSelector((state) => state.details);
  const initialState = {
    showControlReasonsModal: false,
    showRegNumberDetails: false,
    showCustomerDetails: false,
    showDealerDetails: false,
    leftPosition: 0,
    topPosition: 0,
  };

  const [detailHeaderState, setDetailHeaderState] = useState(initialState);

  const openClickAwayListener = (name, buttonName) => {
    const button = document.querySelector(`.${buttonName}`);
    const rect = button.getBoundingClientRect();
    setDetailHeaderState({
      ...detailHeaderState,
      [name]: !detailHeaderState[name],
      leftPosition: rect.left - rect.width / 4,
      topPosition: rect.top + 1.2 * rect.height,
    });
  };
  const changePosition = (name) => {
    const button = document.querySelector(`.${name}`);
    const rect = button.getBoundingClientRect();
    setDetailHeaderState({
      ...detailHeaderState,
      leftPosition: rect.left - rect.width / 4,
      topPosition: rect.top + 1.2 * rect.height,
    });
  };

  useEffect(() => {
    const handleResize = () => {
      if (detailHeaderState.showRegNumberDetails)
        changePosition("regDetails-button");
      if (detailHeaderState.showCustomerDetails)
        changePosition("customerDetails-button");
      if (detailHeaderState.showDealerDetails)
        changePosition("dealerDetails-button");
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <span>
      {detailHeaderState.showControlReasonsModal && (
        <ControlReasonsModal
          caseDetails={caseDetails}
          controlsystem={JSON.parse(caseDetails.response_data)}
          closeControlReasonsModal={() =>
            setDetailHeaderState({
              ...detailHeaderState,
              showControlReasonsModal: false,
            })
          }
        ></ControlReasonsModal>
      )}
      <div className="col-md-12 headpaymentbox" id="headpaymentbox">
        <div className="dt-details_flyoutq">
          <div className="loantopdetail">
            <ul className="clearfix">
              <li className="loandtlblock">
                <div className="caseTxt">Loan ID</div>

                {(() => {
                  const controlsystem = !caseDetails.response_data
                    ? {}
                    : JSON.parse(caseDetails.response_data);
                  if (
                    ["9", "10", "11"].includes(caseDetails.sub_stage) ||
                    RphUserIds.includes(user_id)
                  ) {
                    return (
                      <div className="casedetailTxt">
                        {!caseDetails.lead_id ? "--" : caseDetails.lead_id}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className={`casedetailTxt ${controlsystem.class}`}
                        onClick={(e) => {
                          if (
                            controlsystem.type &&
                            controlsystem.type !== "normal"
                          ) {
                            setDetailHeaderState({
                              ...detailHeaderState,
                              showControlReasonsModal: true,
                            });
                            e.stopPropagation();
                          }
                        }}
                      >
                        {!caseDetails.lead_id ? "--" : caseDetails.lead_id}

                        {controlsystem.type !== "" &&
                          controlsystem.type !== "normal" && (
                            <span className="caret"></span>
                          )}
                      </div>
                    );
                  }
                })()}
              </li>
              <li className="loandtlblock">
                <div className="caseTxt">Bank</div>
                <div className="casedetailTxt">
                  <div className="bankname">
                    <span>
                      {caseDetails.ire_policy_name &&
                      caseDetails.ire_policy_name !== ""
                        ? `${caseDetails.ire_policy_name} ${caseDetails.bank_name}`
                        : caseDetails.bank_name}
                    </span>
                  </div>
                </div>
              </li>
              <li className="loandtlblock">
                <div className="caseTxt">Loan Type</div>
                <div
                  className="casedetailTxt largeTxt"
                  style={{ width: "87%" }}
                  title={caseDetails.loan_type}
                >
                  {caseDetails.loan_type_header}
                </div>
              </li>
              <li className="loandtlblock">
                <div className="caseTxt">Reg Number</div>
                <ClickAwayListener
                  onClickAway={() => {
                    setDetailHeaderState({
                      ...detailHeaderState,
                      showRegNumberDetails: false,
                    });
                  }}
                >
                  <div className="casedetailTxt">
                    {caseDetails.regno !== "" ? caseDetails.regno : "--"}
                    <button
                      className="ic_info regDetails-button"
                      title="Vehicle Details"
                      onClick={() =>
                        openClickAwayListener(
                          "showRegNumberDetails",
                          "regDetails-button",
                        )
                      }
                      disabled={detailsStore.formLoading}
                    >
                      <img
                        src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                        alt=""
                      />
                    </button>
                    {detailHeaderState.showRegNumberDetails && (
                      <Portal>
                        <RegNumberDetails
                          caseDetails={caseDetails}
                          leftPosition={detailHeaderState.leftPosition}
                          topPosition={detailHeaderState.topPosition}
                        ></RegNumberDetails>
                      </Portal>
                    )}
                  </div>
                </ClickAwayListener>
              </li>
              <li className="loandtlblock">
                <div className="caseTxt">Customer Details</div>
                <ClickAwayListener
                  onClickAway={() =>
                    setDetailHeaderState({
                      ...detailHeaderState,
                      showCustomerDetails: false,
                    })
                  }
                >
                  <div className="casedetailTxt">
                    {(() => {
                      const customerName = `${
                        caseDetails.customer_name || ""
                      } ${caseDetails.last_name || ""}`;

                      if (customerName !== "") {
                        return customerName.length > 20
                          ? `${customerName.substring(0, 20)}..`
                          : customerName;
                      } else {
                        return "--";
                      }
                    })()}
                    <button
                      className="ic_info customerDetails-button"
                      title="Customer Details"
                      onClick={() =>
                        openClickAwayListener(
                          "showCustomerDetails",
                          "customerDetails-button",
                        )
                      }
                      disabled={detailsStore.formLoading}
                    >
                      <img
                        src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                        alt=""
                      />
                    </button>
                    {detailHeaderState.showCustomerDetails && (
                      <Portal>
                        <CustomerDetails
                          caseDetails={caseDetails}
                          leftPosition={detailHeaderState.leftPosition}
                          topPosition={detailHeaderState.topPosition}
                        ></CustomerDetails>
                      </Portal>
                    )}
                  </div>
                </ClickAwayListener>
              </li>
              <li className="loandtlblock">
                <div className="caseTxt">Dealer Details</div>
                <ClickAwayListener
                  onClickAway={() =>
                    setDetailHeaderState({
                      ...detailHeaderState,
                      showDealerDetails: false,
                    })
                  }
                >
                  <div className="casedetailTxt">
                    {(() => {
                      const dealerName = caseDetails.dealer_name;
                      if (dealerName && dealerName !== "") {
                        return dealerName.length > 20
                          ? `${dealerName.substring(0, 20)}..`
                          : dealerName;
                      } else {
                        return "--";
                      }
                    })()}
                    <button
                      className="ic_info dealerDetails-button"
                      title="Dealer Details"
                      onClick={() =>
                        openClickAwayListener(
                          "showDealerDetails",
                          "dealerDetails-button",
                        )
                      }
                      disabled={detailsStore.formLoading}
                    >
                      <img
                        src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                        alt=""
                      />
                    </button>
                    {detailHeaderState.showDealerDetails && (
                      <Portal>
                        <DealerDetails
                          caseDetails={caseDetails}
                          leftPosition={detailHeaderState.leftPosition}
                          topPosition={detailHeaderState.topPosition}
                        ></DealerDetails>
                      </Portal>
                    )}
                  </div>
                </ClickAwayListener>
              </li>

              <li className="loandtlblock">
                <div className="caseTxt">City</div>
                <div className="casedetailTxt">
                  {caseDetails.lead_city !== ""
                    ? `${caseDetails.lead_city}`
                    : "--"}
                </div>
              </li>
              {(() => {
                let stage =
                    !caseDetails.stage || statuses.length === 0
                      ? "--"
                      : statuses[caseDetails.stage - 1].label,
                  substage = "Open";

                if (caseDetails.sub_stage && substatuses.length > 0) {
                  if (
                    [3, 4, 12, 14].includes(parseInt(caseDetails.sub_stage))
                  ) {
                    substage = "Discrepancy Identified";
                  } else {
                    substage = substatuses.filter(
                      (substatus) =>
                        substatus.value === parseInt(caseDetails.sub_stage),
                    )[0].label;
                  }
                }

                return (
                  <>
                    <li className="loandtlblock">
                      <div className="caseTxt">LoanBox Status</div>
                      <div className="casedetailTxt">
                        <div className="statuslable">
                          <span>
                            {caseDetails?.lb_status
                              ? caseDetails?.lb_status
                              : "--"}
                          </span>
                        </div>
                      </div>
                    </li>
                    <li className="loandtlblock">
                      <div className="caseTxt">LoanBox Sub-Status</div>
                      <div className="casedetailTxt">
                        <div className="statuslable">
                          <span>
                            {caseDetails?.lb_sub_status
                              ? caseDetails?.lb_sub_status
                              : "--"}
                          </span>
                        </div>
                      </div>
                    </li>

                    <li className="loandtlblock">
                      <div className="caseTxt">Case Status</div>
                      <div className="casedetailTxt">
                        <div className="statuslable">
                          <span>{stage}</span>
                        </div>
                      </div>
                    </li>
                    <li className="loandtlblock">
                      <div className="caseTxt">Substatus</div>
                      <div className="casedetailTxt">
                        <div className="statuslable">
                          <span>{substage}</span>
                        </div>
                      </div>
                    </li>
                  </>
                );
              })()}
            </ul>
          </div>
        </div>
      </div>
    </span>
  );
};

export default DetailHeader;
